<template>
  <div>
    <h4 class="ppad green lighten-2 white-text center" dir="rtl">Welcome to your portal</h4>
    <p id="msgs"></p>
    <div class="row">
    <form class="col s12" id="form">
      <div class="row">
        <div class="input-field col s6">
          <i class="material-icons prefix">account_circle</i>
          <input id="fname" type="text" class="validate">
          <label for="icon_prefix">Full Name</label>
        </div>
        <div class="input-field col s6">
          <i class="material-icons prefix">class</i>
          <input id="semester" type="text" class="validate">
          <label for="icon_prefix">Semester/Section</label>
        </div>
        <div class="input-field col s6">
          <i class="material-icons prefix">subject</i>
          <input id="assignment" type="text" class="validate">
          <label for="icon_prefix">Assignment</label>
        </div>
        <div class="input-field col s6">
          <i class="material-icons prefix">insert_link</i>
          <input id="urls" type="text" class="validate">
          <label for="icon_prefix">Github/GitLab Repository Link</label>
        </div>
        <div class="input-field col s6">
          <a class="waves-effect waves-light btn disabled"  v-on:click.prevent="poststData()">Post</a>
        </div>
      </div>
    </form>
    
  </div>
  <p class="ppad green lighten-4">Total of {{posts.length}} students has submitted their assignments to the system.</p>
  <hr>

  <div class="loadings container" id="loading" v-if="LoadingMSG">
    <div class="preloader-wrapper big active">
      <div class="spinner-layer spinner-blue">
        <div class="circle-clipper left">
          <div class="circle"></div>
        </div><div class="gap-patch">
          <div class="circle"></div>
        </div><div class="circle-clipper right">
          <div class="circle"></div>
        </div>
      </div>

      <div class="spinner-layer spinner-red">
        <div class="circle-clipper left">
          <div class="circle"></div>
        </div><div class="gap-patch">
          <div class="circle"></div>
        </div><div class="circle-clipper right">
          <div class="circle"></div>
        </div>
      </div>

      <div class="spinner-layer spinner-yellow">
        <div class="circle-clipper left">
          <div class="circle"></div>
        </div><div class="gap-patch">
          <div class="circle"></div>
        </div><div class="circle-clipper right">
          <div class="circle"></div>
        </div>
      </div>

      <div class="spinner-layer spinner-green">
        <div class="circle-clipper left">
          <div class="circle"></div>
        </div><div class="gap-patch">
          <div class="circle"></div>
        </div><div class="circle-clipper right">
          <div class="circle"></div>
        </div>
      </div>
    </div>
  </div>

<div class="row">
  <ul class="collapsible col s12 m4 l12"> <!-- Collapsible ul-->
    <li>
      <div class="collapsible-header">Assignments Result</div>
      <div class="collapsible-body">
        <table class="striped responsive-table highlight">
          <thead>
            <tr>
                <th>Full Name</th>
                <th>Semester/Section</th>
                <th>Assignment</th>
                <th>Marks</th>
            </tr>
          </thead>

          <tbody>
            <tr v-for="( post, index ) in posts" :key="index">
              <td>{{post.fname}}</td>
              <td>{{post.semester}}</td>
              <td>First</td>
              <td v-if="post.Marks==0" class="red lighten-4">{{post.Marks}}</td>
              <td v-else>{{post.Marks}}</td>
            </tr>
            <tr><hr></tr>
          </tbody>
          
          <thead>
            <tr>
              <th>Online materials</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td><a href="http://www.cplusplus.com/doc/tutorial/pointers/">C++ Online Source</a></td>
            </tr>
            <tr>
              <td><a href="https://drive.google.com/open?id=1rb-ZKVZjq_kxz5TJS2Nfj-gJDmu8xstr">C++ Book</a></td>
            </tr>
          </tbody>
        </table>
      </div>
    </li>
    <li>
      <div class="collapsible-header">Midterm exam Results</div>
      <div class="collapsible-body">
        <table class="striped responsive-table highlight">
          <thead>
            <tr>
                <th>Full Name</th>
                <th>Actual Score</th>
                <th>Promoted Score</th>
                <th>Total Marks</th>
            </tr>
          </thead>

          <tbody>
            <tr v-for="( post, index ) in posts" :key="index">
              <td>{{post.fname}}</td>
              <td>{{post.mexam}}</td>
              <td>10</td>
              <td v-if="post.mexam=='Missing'">{{post.mexam}}</td>
              <td v-else>{{(10 + post.mexam) >20 ? 20 : post.mexam + 10}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </li>
    <li>
      <div class="collapsible-header">Final exam Results</div>
      <div class="collapsible-body">
        <table class="striped responsive-table highlight">
          <thead>
            <tr>
                <th>Full Name</th>
                <th>Midterm</th>
                <th>Assignments</th>
                <th>Total Marks</th>
            </tr>
          </thead>

          <tbody>
            <tr v-for="( post, index ) in posts" :key="index">
              <td>{{post.fname}}</td>
              <!-- <td>{{post.mexam}}</td> -->
              <td v-if="post.mexam=='Missing'">{{post.mexam}}</td>
              <td v-else>{{(10 + post.mexam) >20 ? 20 : post.mexam + 10}}</td>
              <td>20</td>
              <td>{{post.fexam}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </li>

  </ul> <!--End of Collapsible Content-->
  </div> 
  </div>
</template>
<script>
export default {
  name:"",
  data(){
    return {
      posts:[],
      LoadingMSG:true
    }
  },
  methods: {
    poststData: function() {
      let msgAlert = document.getElementById("msgs");
      let mydd = { 
        fname: document.getElementById("fname").value,
        semester: document.getElementById("semester").value,
        asignment: document.getElementById("assignment").value,
        url: document.getElementById("urls").value
        };
        if(mydd.fname==="" || mydd.semester===""||mydd.url===""){
          msgAlert.setAttribute("class","red lighten-1 btn btn-flat white-text");
          msgAlert.innerHTML='Sorry! You need to fill all fields correctly before posting it.';
          return;
        }else{
          this.$http.post('https://sehidb8.firebaseapp.com/students',{
            fname:mydd.fname,
            semester:mydd.semester,
            asignment:mydd.asignment,
            url:mydd.url,
            Marks:0,
            fexam:"",
            mexam:""
          }).then(function(){
            msgAlert.setAttribute("class","green lighten-3 btn btn-flat white-text");
            msgAlert.innerHTML='Saved! Thank you';
            this.fetchPosts();
          });
        }
    },
    fetchPosts:function(){
      this.$http.get('https://sehidb8.firebaseapp.com/students').then(function(data){
      // this.publications = data;
      this.posts=data.data;
      this.LoadingMSG =false;
    });
    }
  },
  mounted:()=>{
     $('.collapsible').collapsible();
  },
  created(){
    
    this.fetchPosts();
  }
}
</script>
<style scoped>
 .ppad{
  padding: 1%;
}
table th{
  background-color:#ffcc80;
}
.collapsible{
  box-shadow: none;
  border: none;
}
</style>
